import { apolloClient } from "@/plugins/apollo";
import {
  CREATE_EXPERIMENT,
  UPDATE_EXPERIMENT,
  DELETE_EXPERIMENT,
} from "@/graphql";

export default {
  create: ({ commit }, payload) => {
    return apolloClient
      .mutate({ mutation: CREATE_EXPERIMENT, variables: payload })
      .then(({ data }) => commit("add", data.createExperiment))
      .catch((error) => console.error(error));
  },
  update: ({ commit }, payload) => {
    return apolloClient
      .mutate({ mutation: UPDATE_EXPERIMENT, variables: payload })
      .then(({ data }) => commit("update", data.updateExperiment))
      .catch((error) => console.error(error));
  },
  delete: ({ commit }, payload) => {
    return apolloClient
      .mutate({ mutation: DELETE_EXPERIMENT, variables: payload })
      .then(({ data }) => commit("delete", data.deleteExperiment))
      .catch((error) => console.error(error));
  },
};
